<template>
    <div class="flex flex-col gap-4 rounded-[20px] bg-white-gray p-4 lg:gap-5 lg:p-5">
        <div class="flex flex-wrap gap-2">
            <OrdersNavBarButton v-for="item in navItems" :key="item.to" :to="item.to" :selected="isActive(item)">
                {{ item.label }}
            </OrdersNavBarButton>
        </div>
        <div v-if="activeItem?.text">
            <OrdersInfo>
                <span v-html="activeItem.text"></span>
            </OrdersInfo>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed, useRoute } from "#imports";
import OrdersNavBarButton from "~/components/orders/OrdersNavBarButton.vue";
import OrdersInfo from "~/components/orders/OrdersInfo.vue";

type NavItem = {
    label: string;
    to: string;
    text?: string;
    exact?: boolean;
};

const navItems: NavItem[] = [
    { label: "Актуальные заказы", to: "/orders", exact: true },
    { label: "Товары в резерве", to: "/orders/reserved", text: "Товары резервируются для Вас сразу же после добавления в заказ.<br>Срок резерва по умолчанию составляет 4 дня. Срок резерва можно увеличить по согласованию с менеджером.<br>Заказы, просроченные более 4-ёх дней, отменяются автоматически! Просим Вас своевременно оформлять отгрузку."},
    { label: "История заказов", to: "/orders/history" },
];

const normalizePath = (path: string) => path.replace(/\/+$/, "") || "/";
const route = useRoute();
const currentPath = computed(() => normalizePath(route.path));
const isActive = (item: NavItem) => {
    const normalizedTarget = normalizePath(item.to);
    if (item.exact) {
        return currentPath.value === normalizedTarget;
    }
    return currentPath.value === normalizedTarget || currentPath.value.startsWith(`${normalizedTarget}/`);
};

const activeItem = computed(() => navItems.find((item) => isActive(item)) ?? navItems[0]);
</script>
